import { useEffect, useRef } from 'react';
import css from './TopbarLoadingIndicator.module.css';

const BAR_COLOR = '#7c5cff';
const TRACK_COLOR = 'rgba(255, 255, 255, 0.2)';

const TopbarLoadingIndicator = ({
  barColor = BAR_COLOR,
  trackColor = TRACK_COLOR,
}) => {
  const barRef = useRef(null);
  const progressRef = useRef(0);
  const rafRef = useRef(null);

  useEffect(() => {
    const bar = barRef.current;
    if (!bar) return;

    const loop = () => {
      const p = progressRef.current;
      progressRef.current = Math.min(p + 0.05 * (1 - Math.sqrt(p)) ** 2, 0.95);
      bar.style.width = `${progressRef.current * 100}%`;
      rafRef.current = requestAnimationFrame(loop);
    };

    rafRef.current = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(rafRef.current);
  }, []);

  return (
    <div className={css.track} style={{ backgroundColor: trackColor }}>
      <div
        ref={barRef}
        className={css.bar}
        style={{
          backgroundColor: barColor,
          boxShadow: `0 0 8px 1px ${barColor}`,
        }}
      >
        <div
          className={css.blob}
          style={{
            backgroundColor: barColor,
            boxShadow: `0 0 6px 3px ${barColor}`,
          }}
        />
      </div>
    </div>
  );
};

export default TopbarLoadingIndicator;
